import { render, staticRenderFns } from "./ToggleDialogueEffect.vue?vue&type=template&id=7f891285&scoped=true&"
import script from "./ToggleDialogueEffect.vue?vue&type=script&lang=js&"
export * from "./ToggleDialogueEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f891285",
  null
  
)

export default component.exports